import React from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ChevronRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useElementWasVisible} from "@pg-mono/hooks";
import {useUserDevice} from "@pg-mono/user-device";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {IRPStore} from "../../../app/rp_reducer";
import {OfferBoxBase} from "../../../atoms/OfferBoxBase";
import {openForYouModal} from "../../../for_you/state/for_you_modal_slice";
import {ForYouOpenType} from "../../../for_you/types/ForYouOpenType";
import {HotlineConsultantsImages} from "../../../hotline/components/HotlineConsultantsImages";
import {HotlineInfoPoints} from "../../../hotline/components/HotlineInfoPoints";
import {useAppDispatch} from "../../../store/hooks";
import {OfferType} from "../../types/OfferType";
import {useNextPageBoxTracking} from "../tracking/next_page_box_tracking";

interface Props {
    isLastPage: boolean;
    offerTypes: OfferType[];
    nextPageLink: string;
}

export const NextPageBox = (props: Props) => {
    const {isLastPage, offerTypes, nextPageLink} = props;
    const dispatch = useAppDispatch();
    const {isMobile} = useUserDevice();
    const selectedRegions = useSelector((state: IRPStore) => state.offerList.selectedRegions);
    const tracking = useNextPageBoxTracking(selectedRegions.map((region) => region.name).join(", "));
    const nextPageLabel = isMobile ? "Kolejna strona" : "Przejdź do kolejnej strony";

    useElementWasVisible({
        ids: [boxId],
        once: true,
        onElementVisible: () => tracking.onView()
    });

    const onCtaClick = () => {
        tracking.onButtonClick(ctaLabel);
        dispatch(openForYouModal({types: offerTypes, source: PreferencesSurveySource.FOR_YOU_LANDING, openFrom: ForYouOpenType.TILE}));
    };

    const onNextPageClick = () => {
        tracking.onButtonClick(nextPageLabel);
    };

    return (
        <OfferBoxBase className={boxStyle} data-id={boxId}>
            <HotlineConsultantsImages variant="small" className={css({mt: 2})} />

            <Text variant="body_copy_2" align="center" mb={3}>
                Zostaw kontakt, a doradca przygotuje dla Ciebie zestawienie mieszkań.{" "}
            </Text>

            <HotlineInfoPoints className={pointsStyle} />

            <div className={ctaStyle}>
                <Button variant="filled_primary" fullWidth onClick={onCtaClick}>
                    {ctaLabel}
                </Button>

                {!isLastPage && (
                    <Button variant="filled_secondary" iconRight={ChevronRightIcon} fullWidth as="a" href={nextPageLink} onClick={onNextPageClick}>
                        {nextPageLabel}
                    </Button>
                )}
            </div>
        </OfferBoxBase>
    );
};

const boxId = "next-page-box";
const ctaLabel = "Zamów rozmowę";

const boxStyle = css({
    p: 2
});

const pointsStyle = css({
    gap: 1.5
});

const ctaStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1.5,
    marginTop: "auto"
});
import React from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ChevronRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useElementWasVisible} from "@pg-mono/hooks";
import {useUserDevice} from "@pg-mono/user-device";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {IRPStore} from "../../../app/rp_reducer";
import {OfferBoxBase} from "../../../atoms/OfferBoxBase";
import {openForYouModal} from "../../../for_you/state/for_you_modal_slice";
import {ForYouOpenType} from "../../../for_you/types/ForYouOpenType";
import {HotlineConsultantsImages} from "../../../hotline/components/HotlineConsultantsImages";
import {HotlineInfoPoints} from "../../../hotline/components/HotlineInfoPoints";
import {useAppDispatch} from "../../../store/hooks";
import {OfferType} from "../../types/OfferType";
import {useNextPageBoxTracking} from "../tracking/next_page_box_tracking";

interface Props {
    isLastPage: boolean;
    offerTypes: OfferType[];
    nextPageLink: string;
}

export const NextPageBox = (props: Props) => {
    const {isLastPage, offerTypes, nextPageLink} = props;
    const dispatch = useAppDispatch();
    const {isMobile} = useUserDevice();
    const selectedRegions = useSelector((state: IRPStore) => state.offerList.selectedRegions);
    const tracking = useNextPageBoxTracking(selectedRegions.map((region) => region.name).join(", "));
    const nextPageLabel = isMobile ? "Kolejna strona" : "Przejdź do kolejnej strony";

    useElementWasVisible({
        ids: [boxId],
        once: true,
        onElementVisible: () => tracking.onView()
    });

    const onCtaClick = () => {
        tracking.onButtonClick(ctaLabel);
        dispatch(openForYouModal({types: offerTypes, source: PreferencesSurveySource.FOR_YOU_LANDING, openFrom: ForYouOpenType.TILE}));
    };

    const onNextPageClick = () => {
        tracking.onButtonClick(nextPageLabel);
    };

    return (
        <OfferBoxBase className={boxStyle} data-id={boxId}>
            <HotlineConsultantsImages variant="small" className={css({mt: 2})} />

            <Text variant="body_copy_2" align="center" mb={3}>
                Zostaw kontakt, a doradca przygotuje dla Ciebie zestawienie mieszkań.{" "}
            </Text>

            <HotlineInfoPoints className={pointsStyle} />

            <div className={ctaStyle}>
                <Button variant="filled_primary" fullWidth onClick={onCtaClick}>
                    {ctaLabel}
                </Button>

                {!isLastPage && (
                    <Button variant="filled_secondary" iconRight={ChevronRightIcon} fullWidth as="a" href={nextPageLink} onClick={onNextPageClick}>
                        {nextPageLabel}
                    </Button>
                )}
            </div>
        </OfferBoxBase>
    );
};

const boxId = "next-page-box";
const ctaLabel = "Zamów rozmowę";

const boxStyle = css({
    p: 2
});

const pointsStyle = css({
    gap: 1.5
});

const ctaStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1.5,
    marginTop: "auto"
});
